import { Component, Input } from '@angular/core';

@Component({
  selector: 'psc-loader',
  styleUrls: ['loader.component.scss'],
  templateUrl: './loader.component.html'
})
export class LoaderComponent {
  style: 'sun' | 'classic' = 'classic';
  @Input() size: 'big' | 'small' | 'tiny' = 'big';

}
